let nextMediaIdValue = 10000000;

const genMediaId = () => {
    return '' + nextMediaIdValue++;
};

const fleetCar3PreviewMedia = {
    'EVENT_CAR_BUMPED': [{
        mediaId: genMediaId(),
        cameraType: 'CAMERA_ROAD',
        url: 'rob-hacks/ces-demo-vids/fleetcar3_road_preview.jpeg',
        type: 'MEDIA_PREVIEW',
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_CABIN',
        url: 'rob-hacks/ces-demo-vids/fleetcar3_cabin_preview.jpeg',
        type: 'MEDIA_PREVIEW',
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_ROAD',
        url: 'rob-hacks/ces-demo-vids/fleetcar3_road_schlapse_325K_h264-2.mp4', // road cam, index 0 (corresponds to road cam id)
        type: 'MEDIA_PREVIEW_VIDEO',
        status: 'EVENT_MEDIA_UPLOAD_COMPLETED',
        statusTime: new Date(),
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_CABIN',
        url: 'rob-hacks/ces-demo-vids/fleetcar3_cabin_schlapse_325K_h264.mp4', // cabin cam, index 1 (corresponds to camera cam id)
        type: 'MEDIA_PREVIEW_VIDEO',
        status: 'EVENT_MEDIA_UPLOAD_COMPLETED',
        statusTime: new Date(),
    }]
};

const deliveryTruckPreviewMedia = {
    'EVENT_HARD_BRAKING': [{
        mediaId: genMediaId(),
        cameraType: 'CAMERA_ROAD',
        url: 'rob-hacks/ces-demo-vids/deliverytruck_road_preview.jpeg',
        type: 'MEDIA_PREVIEW',
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_CABIN',
        url: 'rob-hacks/ces-demo-vids/deliverytruck_cabin_preview.jpeg',
        type: 'MEDIA_PREVIEW',
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_ROAD',
        url: 'rob-hacks/ces-demo-vids/deliverytruck_road_schlapse_325k_h264.mp4', // road cam, index 0 (corresponds to road cam id)
        type: 'MEDIA_PREVIEW_VIDEO',
        status: 'EVENT_MEDIA_UPLOAD_COMPLETED',
        statusTime: new Date(),
    }, {
        mediaId: genMediaId(),
        cameraType: 'CAMERA_CABIN',
        url: 'rob-hacks/ces-demo-vids/deliverytruck_cabin_schlapse_325k_h264.mp4', // cabin cam, index 1 (corresponds to camera cam id)
        type: 'MEDIA_PREVIEW_VIDEO',
        status: 'EVENT_MEDIA_UPLOAD_COMPLETED',
        statusTime: new Date(),
    }]
};

const fakePreviewVideoMedia = {
    '1a1a1a1a1a6a' : fleetCar3PreviewMedia, // 'Fleet Car #3' for fleetdemo+test
    '1a1a1a1a1a3a' : deliveryTruckPreviewMedia, // 'Delivery Truck', fleetdemo+test@klashwerks.com
    '2a1a1a1a1a6a' : fleetCar3PreviewMedia, // 'Fleet Car #3', fleetdemo@klashwerks.com
    '2a1a1a1a1a1a' : deliveryTruckPreviewMedia, // 'Delivery Truck', fleetdemo@klashwerks.com
};

const DEMO_EVENT_TYPES = [
    "EVENT_ACCIDENT",
    "EVENT_DEMO_MAPBOX_TAILGATING",
    "EVENT_DEMO_MAPBOX_ROLLING_STOP",
    "EVENT_DEMO_MAPBOX_SAFETY_WARNING", // Pedestrian or Cyclist
    "EVENT_DEMO_DS4_ENGINE_STOP",
    "EVENT_DEMO_DS4_ENGINE_START",
    "EVENT_DEMO_DS4_TRUNK_UNLOCK",
    "EVENT_DEMO_DS4_DOOR_UNLOCK",
    "EVENT_DEMO_DS4_ALARM_OFF",
    "EVENT_DEMO_DS4_ALARM_ON",
    "EVENT_DEMO_DS4_DOOR_LOCK",
];

const makeFake = (fakeMedia, overrides) => {
    return {
        ...fakeMedia,
        ...overrides
    };
};

export const addFakeMediaToShowcaseEvents = (ravenUuid, { eventList, media }) => {
    const output = {eventList, media};
    if(fakePreviewVideoMedia[ravenUuid]) {
        output.eventList = eventList.map(event => {
            // Add in fake preview video for the selected events
            const fakePreviewVideos = fakePreviewVideoMedia[ravenUuid][event.type];
            if (fakePreviewVideos) {
                event.mediaList = fakePreviewVideos.map(it => makeFake(it, { ts: event.ts }));
                output.media = output.media.concat(event.mediaList);
                // console.log('adding fakes', event, mediaToAdd);
            }
            return event;
        });
    }
    // console.log('transformEventsAndMedia', ravenUuid, output);
    return output;
    // TODO: override availableOnRaven? (kloud says it's true)
}

export const addFakeEvents = (card) => {
    const geostamps = card.route;
    const refEvents = card.events.slice(0, 2);
    const demoEvents = [];
    const demoEventList = [];
    DEMO_EVENT_TYPES.forEach((type, i) => {
        const geoStamp = geostamps[i % geostamps.length];
        const event = {
            type,
            geoStamp,
            ts: geoStamp.ts,
            duration: 0,
            description: '',
        };
        demoEventList.push({
            ...event,
            mediaList: card.eventList[0].mediaList.map(it=> ({ ...it }))
        });
        refEvents.forEach(re => {
            demoEvents.push({
                ...event,
                media: {
                    ...re.media
                }
            });
        });
    })
    card.eventList = card.eventList.concat(demoEventList).sort((a, b) => a.ts === b.ts ? 0 : a.ts > b.ts ? 1 : -1);
    card.events = card.events.concat(demoEvents).sort((a, b) => a.ts === b.ts ? 0 : a.ts > b.ts ? 1 : -1);
};
